import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { resetPassword } from '../services/services';
import { ResetPasswordInterface } from '../models/resetPasswordInterface';

interface ResetPasswordHookOutput {
  handleSubmit: (data: ResetPasswordInterface) => void;
  loading: boolean;
  error: string | null;
  success: boolean;
}

const useResetPassword = (token: string): ResetPasswordHookOutput => {
  const { t } = useTranslation('common');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const handleSubmit = useCallback(
    async (data: ResetPasswordInterface) => {
      try {
        setLoading(true);
        setError(null);
        await resetPassword(token, data);
        setSuccess(true);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(t('messages.errorTryLater'));
      }
    },
    [t, token],
  );

  return {
    handleSubmit,
    loading,
    error,
    success,
  };
};

export default useResetPassword;
